import React from 'react';
import { graphql } from 'gatsby';

import AboutSection from '@components/about-section';
import Layout from '@components/layout';
import HeroSection from '@components/hero-section';
import Carousel from '@components/carousel';
import { buildings } from '@data/keso-invest-u-izgradnji.json';
import company from '@data/company.json';

const KesoInvestPage = ({ data }) => {
  const imageMap = {};
  data.investImages.edges.forEach(({ node }) => {
    imageMap[node.relativePath] = node.childImageSharp.fluid;
  });

  return (
    <Layout pagePath="/keso-invest" pageTitle="Keso Invest" pageDescription="Investiranje i gradnja stambenog i poslovnog prostora vrhunskog kvaliteta u Novom Sadu.">
      <HeroSection cn="invest">
        <h1>Prodaja stambeno-poslovnih prostora</h1>
      </HeroSection>
      <AboutSection>
        <p>
          Kompanija Keso Invest d.o.o. posluje sa ciljem da obezbjedi investiranje
          i gradnju stambenog i poslovnog prostora vrhunskog kvaliteta na
          teritoriji grada Novog Sada.
        </p>
        <p>
          Djelatnost preduzeća je isključivo izgradnja i prodaja stanova i
          poslovnog prostora.
        </p>
        <p>Za više informacija možete nas pozvati na broj <a href={`tel:${company.divisions.kesoInvest.phone.replace(/[\s-]/g, '')}`}>{company.divisions.kesoInvest.phone}</a>.</p>
      </AboutSection>

      <section className="pb-0">
        <div className="container">
          {buildings.map(building => {
            const images = (building.images || [])
              .map(file => ({ fluid: imageMap[file] }))
              .filter(img => img.fluid);

            return (
              <div key={`zgrada-${building.key}`}>
                <Carousel
                  name={building.key}
                  description={
                    <>
                      {building.description}
                      {building.phone && (
                        <> Za više informacija, pozovite na broj{' '}
                          <a href={`tel:${building.phone.replace(/[\s-]/g, '')}`}>{building.phone}</a>
                          {building.email && (
                            <>, ili pošaljite mejl na adresu{' '}
                              <a href={`mailto:${building.email}`}>{building.email}</a>
                            </>
                          )}
                        </>
                      )}
                    </>
                  }
                  location={building.location}
                  images={images}
                  altText="Stambeno-poslovni objekat"
                  navPosition="bottom"
                />
              </div>
            );
          })}
        </div>
      </section>
    </Layout>
  );
};

export const query = graphql`
  query {
    investImages: allFile(filter: { relativeDirectory: { eq: "keso-invest" } }) {
      edges {
        node {
          relativePath
          childImageSharp {
            fluid(maxWidth: 800, quality: 80) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;

export default KesoInvestPage;
